module.exports = require("@swa-ui/core/src/NumberSelector/NumberSelector.module.scss");